/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Integrations_Scope_Project_HintInputs */



/**
* | output |
* | --- |
* | "Link one of your connections into a project (Project → References → Tool connections) before the assistant can use it there." |
*
* @param {My_Integrations_Scope_Project_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const my_integrations_scope_project_hint = /** @type {((inputs?: My_Integrations_Scope_Project_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Integrations_Scope_Project_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verbinden Sie eine Ihrer Verbindungen mit einem Projekt (Projekt → Referenzen → Tool-Verbindungen), damit der Assistent sie dort nutzen kann.")
	return /** @type {LocalizedString} */ ("Link one of your connections into a project (Project → References → Tool connections) before the assistant can use it there.")
});